import { MODEL_PREVIEW_APP_BASE } from "@/constants/model-preview-app.const";

/** External preview app — full navigation (not an in-SPA route). */
export default function ModelsPreviewRedirectPage() {
  if (typeof window !== "undefined") {
    window.location.replace(`${MODEL_PREVIEW_APP_BASE}/local`);
  }
  return (
    <main style={{ padding: 24, color: "var(--color-text)" }}>
      Opening model preview…
    </main>
  );
}
